import { createSlice } from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/consumptionHistory/ConsumptionHistoryUIHelpers";

const initialConsumptionHistoryState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  objectsData: [],
  queryParams: initialFilter,
  cleanRefFilters: false
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const consumptionHistorySlice = createSlice({
  name: "consumptionHistory",
  initialState: initialConsumptionHistoryState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getConsumptionHistoryById
    consumptionHistoryFetched: (state, action) => {
      state.actionsLoading = false;
      state.consumptionHistoryForEdit = action.payload.consumptionHistoryForEdit;
      state.error = null;
    },
    // findConsumptionHistory
    consumptionHistoryFetchedAll: (state, action) => {
      const { totalCount, entities, pageSize, pageNumber } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.queryParams.pageSize = pageSize;
      state.queryParams.pageNumber = pageNumber;
    },
    // Query Params
    updateQueryParams: (state, action) => {
      state.queryParams = action.payload.queryParams;
    },
    updateQueryParamsAndReset: (state, action) => {
      state.queryParams = action.payload.queryParams;
      state.entities = [];
      state.totalCount = 0;
    },
    // ObjectsData
    objectsDataFetchedByType: (state, action) => {
      const { objectsData } = action.payload;
      state.error = null;
      state.objectsData = objectsData.map(x => {
        return {...x, label: `${x.searchKey} | ${x.objectType}`}
      });
      state.actionsLoading = false;
    },
    // Clean Filter
    setValueCleanRefFilter: (state, action) => {
      state.cleanRefFilters= action.payload.flag;
      state.queryParams = action.payload.queryParams;
      state.entities = [];
      state.totalCount = 0;
    },
    endCleanRefFilter: (state, action) => {
      state.cleanRefFilters= action.payload.flag;
    },
  }

});
